import React from 'react';
import PropTypes from 'prop-types';
import { useTranslation } from 'next-i18next';

import Tab from './Tab';

import { Wrapper, TabsWrapper } from './styles';

const Tabs = ({ tabs, selectedTab, onSelectTab }) => {
  const { t } = useTranslation();

  const { content: Content } = tabs.find(({ id }) => id === selectedTab) || {};

  return (
    <Wrapper>
      <TabsWrapper>
        {tabs.map(({ id, label }) => (
          <Tab key={id} id={id} label={t(label)} isSelected={label === selectedTab} onClick={onSelectTab} />
        ))}
      </TabsWrapper>
      {Content}
    </Wrapper>
  );
};

Tabs.propTypes = {
  tabs: PropTypes.array.isRequired,
  selectedTab: PropTypes.string,
  onSelectTab: PropTypes.func
};

export default Tabs;
